import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Star from '@mdi/svg/svg/star.svg';
import StarOutline from '@mdi/svg/svg/star-outline.svg';

import styles from 'src/components/Tile/TileActionsToggle.scss';


class TileActionsToggle extends PureComponent {
  render() {
    const { isFavourite, toggleFavourite } = this.props;
    const favouriteClasses = classNames(styles.star, {
      [styles['star--favourite']]: isFavourite
    });
    const title = isFavourite ? 'Usuń z zapisanych' : 'Zapisz ofertę';

    return (
      <button
        className={ favouriteClasses }
        data-test="button-toggleFavourite"
        onClick={ toggleFavourite }
        title={ title }
        type="button"
      >
        {isFavourite ? <Star viewBox="0 0 24 24" /> : <StarOutline viewBox="0 0 24 24" />}
      </button>
    );
  }
}

TileActionsToggle.propTypes = {
  isFavourite: PropTypes.bool.isRequired,
  toggleFavourite: PropTypes.func.isRequired
};


export default TileActionsToggle;
